<template>
  <div>
    <a-divider class="hidden lg:block" />
    <div class="comment">
      <div class="info">
        <div class="self-center mr-2">
          <i class="icon icon-bor-avartar mr-2" />
          <span class="f-14">○○さん（30代後半／女性）<br class="hidden lg:block" ></span>
          <span class="f-14 ml-4">投稿日：○年○月○日</span>
        </div>
        <div v-if="editable">
          <button class="c-btn-cm btn-white">
            <i class="icon icon-bor-take-note" />
            編集
          </button>      
        </div>
      </div>
      <div class="rating flex">
        <Rating rate="4.5" />
      </div>
      <div class="post">
        <div class="title mb-2">クチコミ見出しクチコミ見出しクチコミ見出しクチコミ見出しクチコミ見出し</div>
        <p class="content">
          クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。
          クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。
          クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。
          クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。
          クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。
          クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。
          クチコミ本文が入ります。クチコミ本文が入ります。クチコミ本文が入ります。
        </p>
        <div class="date">
          <div class="mr-6">利用日：0000年00月00日</div>
          <div>プラン名:○○○○○○】○○○○○</div>
        </div>
        <div class="help-full">
          <div class="flex">
            <button v-if="post_type" class="c-btn-cm btn-white">参考になった</button>
            <span class="ml-2 self-center">00人が「参考になった」と回答しています。</span>
          </div>
          <div class="btn-end">
            <button v-if="post_type" class="c-btn-cm btn-white">通報する</button>
          </div>
        </div>
      </div>
      <a-divider />
      <div class="reply ml-4">
        <div class="info">
          <div class="self-center mr-2">
            <i class="icon icon-bor-avartar mr-2" />
            <span class="f-14">○○さん（30代後半／女性）<br class="hidden lg:block" ></span>
            <span class="f-14 ml-4">投稿日：○年○月○日</span>
          </div>
          <div class="content">
            この度は○○○○○ホテルをご利用いただきまして、誠にありがとうございます。
            返信が入ります。返信が入ります。返信が入ります。返信が入ります。返信が入ります。
            返信が入ります。返信が入ります。返信が入ります。返信が入ります。返信が入ります。
            返信が入ります。返信が入ります。返信が入ります。返信が入ります。返信が入ります。
            返信が入ります。返信が入ります。返信が入ります。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Rating } from '@/components/primitive'
export default {
  name: 'Comment',
  props: ['editable', 'post_type'],
  components: {
    Rating
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>